/** Client for the governed query API (task 4140.6). */
import { apiFetch } from "../../app/api";

const BASE = "/api/v1/knowledge";

export interface Citation {
  segment_id: string;
  segment_key: string;
  source_authority: string;
  document_revision: string | null;
  lifecycle_state: string;
  region_id: string;
  region_key: string;
  region_kind: string;
  page_number: number | null;
  sheet_name: string | null;
  cell_ref: string | null;
  parsed_document_id: string;
}

export interface QueryReply {
  query_id: string;
  status: "answered" | "declined" | "failed";
  answer: string | null;
  limitations: string[];
  citations: Citation[];
  decline_code: string | null;
  decline_reason: string | null;
  withheld: Record<string, number>;
  retrieval_policy_version: number;
}

export interface Question {
  engagement_id: string;
  question: string;
  question_class: string;
  run_id?: string;
}

export function message(caught: unknown): string {
  return caught instanceof Error ? caught.message : String(caught);
}

export function ask(question: Question): Promise<QueryReply> {
  return apiFetch<QueryReply>(`${BASE}/query`, { method: "POST", body: JSON.stringify(question) });
}

export function getSegment(segmentId: string): Promise<Citation> {
  return apiFetch<Citation>(`${BASE}/segments/${encodeURIComponent(segmentId)}`);
}

/** Where a citation sits, in the terms a reader looks for it. */
export function citationPlace(citation: Citation): string {
  const parts = [
    citation.sheet_name && `sheet ${citation.sheet_name}`,
    citation.cell_ref && `cell ${citation.cell_ref}`,
    citation.page_number !== null && `page ${citation.page_number}`,
    `${citation.region_kind} ${citation.region_key}`,
  ];
  return parts.filter(Boolean).join(", ");
}
